import { breakpoints, css } from '../../../styles/theme';
import { rem } from 'polished';
import { FilterBoxProps } from './index';

export const StylesDS = css<FilterBoxProps>`
    @media (min-width: ${breakpoints.md}px) {
        padding: ${rem(13)} ${rem(26)};
        ${({ isHomepage, theme }) => (isHomepage ? '' : `border-bottom: 2px solid ${theme.colors.grey24};`)}
    }

    .color-filter-item {
        border-radius: unset !important;

        &::after {
            border-radius: unset !important;
        }
    }

    .reset-filters--button {
        font-family: DSAutomobiles;
        font-style: normal;
        font-weight: normal;
        font-size: ${rem(16)};
        line-height: ${rem(24)};
        color: ${({ theme }) => theme.colors.primary};

        @media (min-width: ${breakpoints.md}px) {
            bottom: ${rem(16)};

            &.filters-reset-finance-journey {
                bottom: ${rem(46)};
            }
        }
    }

    .frontpage-legaltext-over {
        margin: ${rem(16)} 0 0 0;
        padding-top: 0;
    }

    .filter-buttons-wrapper {
        button {
            min-height: ${rem(48)};
            padding: 0;
        }
    }

    .filterbox-body {
        @media (min-width: ${breakpoints.md}px) {
            > div:nth-child(n) {
                max-width: ${rem(380)};
            }

            > div:nth-child(3) {
                max-width: ${rem(320)};
            }
        }
    }

    .filter-title {
        font-family: DSAutomobiles;
        font-style: normal;
        font-weight: normal;
        font-size: ${rem(20)};
        line-height: ${rem(20)};
        padding: 0;
    }

    .frontpage-legaltext {
        font-size: ${rem(12)};
    }

    .geolocation-filter-label {
        font-size: ${rem(14)};
    }

    .disp-inline {
        display: inline-flex;
        width: 100%;
        justify-content: space-around;
        align-items: center;
        padding: 0 ${rem(10)};
        svg {
            width: ${rem(17)};
        }
        span {
            margin-left: auto;
        }
    }

    .geolocation-input--container {
        label {
            font-size: ${rem(14)};
        }

        .geolocation-input--select-container {
            text-transform: uppercase;
        }
    }

    /* normalize filter - buttons, do not even dare remove this */
    .filter-buttons-wrapper {
        &.onMobile-hidden {
            min-width: ${rem('250px')};
        }
    }

    .filterbox-body {
        .stock-generated-filter-button {
            min-width: unset !important;
            max-width: unset !important;
            max-height: unset !important;
            margin: 0;
            padding: 0;
        }
    }

    .filterbox-collapse-button {
        background: ${({ theme }) => theme.colors.grey24};
        border-radius: 0;
        span {
            position: relative;
            top: -2px;
        }
    }
`;
